<template>
  <div class="feladat-details-page">
    <navigation-bar />

    <!-- KOPF / FELADAT-DETAILS -->
    <div class="header-card" v-if="feladat">
      <div class="header-top">
        <div class="main-info">
          <h2>
            Feladat részletei
            <span class="id-pill">#{{ feladat.az }}</span>
          </h2>
          <div class="status-pill" :class="statusClass">
            {{ statusLabel }}
          </div>
        </div>

        <div class="header-actions">
          <button @click="$router.back()">Vissza</button>
        </div>
      </div>

      <!-- 3-Spalten Layout -->
      <div class="details-grid">
        <!-- LINKE SPALTE -->
        <div class="details-col">
          <table class="info-table">
              <tbody>
            <tr>
              <th>Rendszám</th>
              <td>{{ feladat.rendszam }}</td>
            </tr>
            <tr>
              <th>Dátum</th>
              <td>{{ feladat.datum }}</td>
            </tr>
            <tr>
              <th>Le dátum</th>
              <td>{{ feladat.le_datum }}</td>
            </tr>
            <tr>
              <th>Felrakó</th>
              <td>{{ feladat.felrako }}</td>
            </tr>
            <tr>
              <th>Lerakó</th>
              <td>{{ feladat.lerako }}</td>
            </tr>
            <tr>
              <th>Cikk</th>
              <td>{{ feladat.cikk }}</td>
            </tr>
            <tr>
              <th>Do. szám</th>
              <td>{{ feladat.do_szam }}</td>
            </tr>
            <tr>
              <th>Felrakási azonosító</th>
              <td>{{ feladat.felrakasi_azonosito }}</td>
            </tr>
            <tr>
              <th>Lerakási azonosító</th>
              <td>{{ feladat.lerakasi_azonosito }}</td>
            </tr>
            </tbody>
          </table>
        </div>

        <!-- MITTLERE SPALTE -->
        <div class="details-col">
          <table class="info-table">
              <tbody>
            <tr>
              <th>Fuvarszervező</th>
              <td>{{ feladat.fuvarszervezo }}</td>
            </tr>
            <tr>
              <th>Diszpécser</th>
              <td>{{ feladat.diszpecser }}</td>
            </tr>
            <tr>
              <th>Sofőr</th>
              <td>{{ feladat.sofor }}</td>
            </tr>

            <!-- Status-Felder mit X / ✓ -->
            <tr>
              <th>Tervezés kész</th>
              <td>
                <span :class="statusIconClass(feladat.tervezes_kesz)">
                  {{ statusIconChar(feladat.tervezes_kesz) }}
                </span>
              </td>
            </tr>
            <tr>
              <th>Elküldve WS</th>
              <td>
                <span :class="statusIconClass(feladat.elkuldve_WS)">
                  {{ statusIconChar(feladat.elkuldve_WS) }}
                </span>
              </td>
            </tr>
            <tr>
              <th>Szállítás kész</th>
              <td>
                <span :class="statusIconClass(feladat.kesz)">
                  {{ statusIconChar(feladat.kesz) }}
                </span>
              </td>
            </tr>
            <tr>
              <th>Stornó</th>
              <td>
                <span :class="statusIconClass(feladat.storno)">
                  {{ statusIconChar(feladat.storno) }}
                </span>
              </td>
            </tr>
            <tr>
              <th>Stornó elküldve</th>
              <td>
                <span :class="statusIconClass(feladat.storno_elkuldve)">
                  {{ statusIconChar(feladat.storno_elkuldve) }}
                </span>
              </td>
            </tr>

            <!-- ggf. Megrendelés / napi mellék unten dranhängen -->
            <tr>
              <th>Megrendelés AZ</th>
              <td>{{ feladat.m_az }} - {{ feladat.napi_mellekAZ }}</td>
            </tr>
            <tr>
              <th>Módosította</th>
              <td>{{ feladat.mod_felh }}</td>
            </tr>
            </tbody>
          </table>
        </div>

        <!-- RECHTE SPALTE: Sofőr infó -->
        <div class="details-col sofor-col">
          <h4>Sofőr infó</h4>
          <div
            v-if="hasSoforInfo"
            class="sofor-info-box"
            v-html="feladat ? feladat.sofor_info : ''"
          ></div>
          <div v-else class="sofor-info-empty">
            Nincs sofőr infó.
          </div>
        </div>
      </div>
    </div>

    <!-- Lade-/Fehlertexte -->
    <div v-if="error" class="error">{{ error }}</div>
    <div v-if="loading" class="loading">Adatok töltése…</div>

    <!-- TERV ÚTVONALAK -->
    <div v-if="!loading" class="utvonalak-block">
      <h3>Terv útvonalak</h3>

      <table v-if="utvonalak.length" class="utvonalak-table">
        <thead>
          <tr>
            <th>Sorrend</th>
             <th>Útvonal típus</th>
            <th>Indulás – felrakó / GPS / dátum</th>
            <th>Érkezés – lerakó / GPS / dátum</th>
           
            <th>Útvonal</th>
            <th>Közbenső pontok</th>
            <th>Elküldve</th>
            <th>Stornó</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="u in utvonalak" :key="u.az">
            <td class="center">{{ u.fordulo }}</td>
            <td>{{ u.tipus }}</td>
            <td>
              <div class="main">{{ u.felrako }}</div>
              <div class="sub" v-if="u.ind_gps">GPS: {{ u.ind_gps }}</div>
              <div class="sub" v-if="u.datum">Dátum: {{ u.datum }}</div>
            </td>

            <td>
              <div class="main">{{ u.lerako }}</div>
              <div class="sub" v-if="u.erk_gps">GPS: {{ u.erk_gps }}</div>
              <div class="sub" v-if="u.le_datum">Dátum: {{ u.le_datum }}</div>
            </td>

            
            <td>{{ u.utvonal }}</td>
            <td>{{ u.pontok }}</td>

            <td class="center">
              <span class="flag small" :class="{ on: u.elkuldve == 1 }">
                {{ u.elkuldve == 1 ? 'Igen' : 'Nem' }}
              </span>
            </td>

            <td class="center">
              <span class="flag small" :class="{ on: u.storno == 1 }">
                {{ u.storno == 1 ? 'Igen' : 'Nem' }}
              </span>
            </td>
          </tr>
        </tbody>
      </table>

      <div v-if="!utvonalak.length" class="no-data">
        Nincs rögzített útvonal ehhez a feladathoz.
      </div>
    </div>
  </div>
</template>

<script>
import axiosInstance from '@/axiosInstance';
import NavigationBar from '@/views/NavigationBar.vue';
import { mapGetters } from 'vuex';

export default {
  name: 'FeladatDetails',
  components: { NavigationBar },

  props: {
    id: {
      type: [String, Number],
      required: true
    }
  },

  data() {
    return {
      feladat: null,
      utvonalak: [],
      loading: false,
      error: null
    };
  },

  computed: {
    ...mapGetters(['getUserData']),

    ceg_az() {
      return this.getUserData ? this.getUserData.ceg_az : null;
    },

    feladatId() {
      return Number(this.id || this.$route.params.id);
    },

    hasSoforInfo() {
      const txt = (this.feladat && this.feladat.sofor_info) || '';
      return txt.trim().length > 0;
    },

    statusLabel() {
      if (!this.feladat) return '';
      const s = String(this.feladat.szallitas_status ?? '');
      switch (s) {
        case '0': return 'Tervezett / nyitott';
        case '10': return 'Küldésre vár';
        case '20': return 'Adatok elküldve a sofőrnek';
        case '30': return 'Úton a felrakóra';
        case '40': return 'Felrakáson / rakodás';
        case '50': return 'Úton a lerakóra';
        case '60': return 'Lerakáson / lerakás';
        case '70': return 'Lerakás kész – zárásra vár';
        case '80': return 'Szállítás kész';
        case '90': return 'Stornózott feladat';
        default:  return 'Ismeretlen státusz';
      }
    },

    statusClass() {
      if (!this.feladat) return '';
      const s = String(this.feladat.szallitas_status ?? '');
      return {
        'st-nyitott': ['0', '10'].includes(s),
        'st-folyamatban': ['20', '30', '40', '50', '60', '70'].includes(s),
        'st-kesz': s === '80',
        'st-storno': s === '90'
      };
    }
  },

  async mounted() {
    if (!this.ceg_az) {
      this.error = 'Hiányzik a cég_az.';
      return;
    }
    this.loading = true;
    try {
      await this.loadFeladat();
      await this.loadUtvonalak();
    } finally {
      this.loading = false;
    }
  },

  methods: {
    async loadFeladat() {
      const payload = {
        ceg_az: this.ceg_az,
        az: this.feladatId
      };

      const resp = await axiosInstance.post(
        '/m_feladat/get_feladat.php',
        payload,
        { headers: { 'Content-Type': 'application/json' } }
      );

      console.log('🔹 get_feladat response:', resp.data);
      this.feladat = resp.data?.data || null;

      if (!this.feladat) {
        this.error = 'Nem található feladat a megadott az alapján.';
      }
    },

    async loadUtvonalak() {
      if (!this.feladatId) {
        this.utvonalak = [];
        return;
      }

      const payload = {
        ceg_az: this.ceg_az,
        feladat_az: this.feladatId
      };

      const resp = await axiosInstance.post(
        '/m_utvonal/list_utvonalak.php',
        payload,
        { headers: { 'Content-Type': 'application/json' } }
      );

      console.log('🔹 list_utvonalak response:', resp.data);
      this.utvonalak = resp.data?.data || [];
    },

    // X / ✓ je nach Wert (0 = rot X, -1 = grüner Haken).
    // Falls du in MySQL 0/1 speicherst, kannst du 1 zusätzlich zulassen.
    statusIconChar(value) {
      const v = Number(value ?? 0);
      return v === 0 ? '✗' : '✓'; // alles !=0 als "an"
      // wenn du *nur* -1 als "an" möchtest:
      // return v === -1 ? '✓' : '✗';
    },
    statusIconClass(value) {
      const v = Number(value ?? 0);
      const isOn = v !== 0; // oder: const isOn = v === -1;
      return isOn ? 'status-ok' : 'status-bad';
    }
  }
};
</script>

<style scoped>
.feladat-details-page {
  padding: 10px 16px;
}

.header-card {
  border: 1px solid #ccc;
  border-radius: 6px;
  padding: 10px 12px;
  margin-bottom: 16px;
  background: #fafafa;
}

.header-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}

.main-info {
  display: flex;
  align-items: center;
  gap: 8px;
}

.id-pill {
  font-size: 0.85rem;
  background: #e9ecef;
  padding: 2px 6px;
  border-radius: 4px;
}

.status-pill {
  font-size: 0.8rem;
  padding: 3px 8px;
  border-radius: 999px;
  border: 1px solid transparent;
}

/* Status-Farben im Kopf */
.st-nyitott {
  background: #fff3cd;
  border-color: #ffeeba;
}
.st-folyamatban {
  background: #cce5ff;
  border-color: #b8daff;
}
.st-kesz {
  background: #d4edda;
  border-color: #c3e6cb;
}
.st-storno {
  background: #f8d7da;
  border-color: #f5c6cb;
}

/* 3-Spalten Layout */
.details-grid {
  display: grid;
  grid-template-columns: 1.1fr 1.1fr 1.4fr;
  gap: 12px;
  margin-bottom: 8px;
}

.details-col {
  font-size: 0.85rem;
}

.info-table {
  width: 100%;
  border-collapse: collapse;
}

.info-table th,
.info-table td {
  padding: 2px 4px;
  border-bottom: 1px dotted #ddd;
  vertical-align: top;
}

.info-table th {
  text-align: right;
  white-space: nowrap;
  color: #555;
  font-weight: 600;
}

.info-table td {
  padding-left: 8px;
}

/* Sofőr info Spalte */
.sofor-col {
  display: flex;
  flex-direction: column;
}

.sofor-col h4 {
  margin: 0 0 4px 0;
  font-size: 0.85rem;
}

.sofor-info-box {
  flex: 1;
  border: 1px solid #ccc;
  border-radius: 4px;
  background: #ffffff;
  padding: 6px 8px;
  max-height: 220px;
  overflow-y: auto;
  font-size: 0.8rem;
  line-height: 1.3;
  text-align: left; /* explizit links ausrichten */
}

.sofor-info-box div {
  margin-bottom: 2px;
}

.sofor-info-empty {
  flex: 1;
  padding: 6px 8px;
  border: 1px dashed #ccc;
  border-radius: 4px;
  font-size: 0.8rem;
  color: #777;
  text-align: left;
}

/* Status-Icons (X / ✓) */
.status-ok {
  color: #28a745;
  font-weight: 700;
}
.status-bad {
  color: #dc3545;
  font-weight: 700;
}

/* Tabelle unten */
.flag.small {
  font-size: 0.75rem;
  padding: 1px 4px;
  border-radius: 4px;
  border: 1px solid #ccc;
  background: #f8f9fa;
}
.flag.small.on {
  background: #007bff;
  color: #fff;
  border-color: #007bff;
}

.utvonalak-block h3 {
  margin: 0 0 6px 0;
}

.utvonalak-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.85rem;
}

.utvonalak-table th,
.utvonalak-table td {
  border: 1px solid #ccc;
  padding: 4px 6px;
  vertical-align: top;
}

.utvonalak-table th {
  background: #e9ecef;
}

.center {
  text-align: center;
}

.main {
  font-weight: 600;
}
.sub {
  font-size: 0.75rem;
  color: #555;
}

.loading,
.error,
.no-data {
  margin-top: 12px;
  font-size: 0.9rem;
}
.error {
  color: #b00020;
}
</style>
